var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{key:_vm.name,staticClass:"o-icon",domProps:{"innerHTML":_vm._s(_vm.icons[_vm.name])},on:{"click":function($event){return _vm.$emit('click', $event)},"mousedown":function($event){return _vm.$emit('mousedown', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }